import React, { useState } from 'react';
import { formatPercent } from 'utils';
import FieldPercent from '../FieldPercent/FieldPercent';
import CloseRoundedIcon from '@material-ui/icons/CloseRounded';
import Icons from 'components/Icons';
import Fields from 'components/Fields';
import { Tooltip } from '@material-ui/core';
import { change, formValueSelector } from 'redux-form';
import Store from 'store/store';
import { compose } from 'ramda';

const { connect } = Store;

interface EditablePercentProps {
  name: string;
  formName: string;
  defaultValue: string;
  changeField: Function;
  value: any;
  onChange?: Function;
  onUnset?: Function;
}

const EditablePercent = ({
  name,
  formName,
  defaultValue,
  changeField,
  value,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onUnset = () => {}
}: EditablePercentProps) => {
  const [isEditing, setIsEditing] = useState(
    value !== null && value !== undefined
  );
  const formattedDefaultValue = isNaN(parseFloat(defaultValue))
    ? defaultValue
    : formatPercent(Number(defaultValue) * 100);
  const formattedValue = formatPercent(Number(value) * 100);

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.25rem',
        width: '100%'
      }}
    >
      {!isEditing ? (
        <>
          <div style={{ flex: 1 }}>{formattedDefaultValue}</div>
          <Icons.Edit
            onClick={() => setIsEditing(true)}
            style={{ cursor: 'pointer', color: '#000' }}
          />
        </>
      ) : (
        <>
          <FieldPercent
            name={name}
            component={Fields.Text}
            validate={[Fields.Validators.required]}
            style={{ minWidth: '50px' }}
            value={formattedValue}
            onChange={onChange}
          />
          <Tooltip
            title={`Revert to original value: ${formattedDefaultValue}`}
            arrow
          >
            <CloseRoundedIcon
              style={{ height: '24px' }}
              onClick={() => {
                setIsEditing(false);
                changeField(formName, name, formattedDefaultValue);
                onUnset();
              }}
            />
          </Tooltip>
        </>
      )}
    </div>
  );
};

export default compose(
  connect(
    (state: any, props: any) => ({
      value: formValueSelector(props.formName)(state, props.name)
    }),
    {
      changeField: change
    }
  )
)(EditablePercent);
